import React, { useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { isInt } from 'validator';
import { useSelector } from 'react-redux';

import Loading from '../../components/Loading';
import { Container, Form } from '../../styles/GlobalStyles';
import { Adicionar } from './styled';
import axios from '../../services/axios';
import Modal from '../../components/Modal';

export default function Disciplina({ match }) {
  const nivel = useSelector((state) => state.auth.user.nivel);

  const id = get(match, 'params.id', '');

  const [isLoading, setIsLoading] = useState(false);
  const [nivelCurso, setNivelCurso] = useState('');
  const [descricaoDisciplina, setDescricaoDisciplina] = useState('');
  const [quantidadeQuestoes, setQuantidadeQuestoes] = useState('');
  const [reutilizarProva, setReutilizarProva] = useState('');
  const [tiposProva, setTiposProva] = useState('');
  const [idCadastrado, setIdCadastrado] = useState('');
  const [result, setResult] = useState([]);
  const [show, setShow] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (nivelCurso.length < 3 || nivelCurso.length > 100) {
      toast.error('Nível do curso precisa ter entre 3 e 100 caracteres');
      formErros = true;
    }

    if (descricaoDisciplina.length < 3 || descricaoDisciplina.length > 100) {
      toast.error('Descrisção da disciplina precisa ter entre 3 e 100 caracteres');
      formErros = true;
    }

    if (quantidadeQuestoes < 5 || quantidadeQuestoes > 20) {
      toast.error('A quantidade de questões deve ser entre 5 e 20 questoes');
      formErros = true;
    }

    if (!isInt(String(quantidadeQuestoes))) {
      toast.error('Quantidade de questões inválida');
      formErros = true;
    }

    if (tiposProva < 1 || tiposProva > 3) {
      toast.error('A quantidade de provas deve ser entre 1 e 3 provas');
      formErros = true;
    }

    if (!isInt(String(tiposProva))) {
      toast.error('Tipo de prova inválida');
      formErros = true;
    }

    if (formErros) return;

    if (nivel === '1') {
      toast.error('Você não tem permissão para prosseguir com essa ação.');
      return;
    }

    if (!idCadastrado) {
      setIsLoading(true);
      axios.post('/disciplina/', {
        id_identificacao_empresa: id,
        curso_nivel: nivelCurso,
        descricao_disciplina: descricaoDisciplina,
        quantidade_questoes: quantidadeQuestoes,
        utilizar_mesma_prova: reutilizarProva,
        tipos_de_prova: tiposProva,
      }).then((response) => {
        setIsLoading(false);
        toast.success('Disciplina cadastrada com sucesso!');
        setIdCadastrado(response.data.id);
      }).catch(() => {
        setIsLoading(false);
        toast.error('Erro ao cadastrar disciplina!');
      });
    } else {
      setIsLoading(true);
      axios.put(`/disciplina/${idCadastrado}`, {
        curso_nivel: nivelCurso,
        descricao_disciplina: descricaoDisciplina,
        quantidade_questoes: quantidadeQuestoes,
        utilizar_mesma_prova: reutilizarProva,
        tipos_de_prova: tiposProva,
      }).then(() => {
        setIsLoading(false);
        toast.success('Disciplina editada com sucesso!');
      }).catch((er) => {
        setIsLoading(false);

        const errors = get(er, 'response.data.error', []);
        const status = get(er, 'response.status', 0);

        if (status === 401) {
          toast.error('Você precisa fazer login novamente.');
        }

        if (errors.length > 0) {
          errors.map((error) => toast.error(error));
        } else {
          toast.error('Erro desconhecido');
        }
      });
    }
  };

  const getDatas = async (value) => {
    try {
      setIsLoading(true);
      const response = await axios('/disciplina/');
      const results = response.data;

      const filtrar = [
        ...results.filter((res) => ((res.id_identificacao_empresa === Number(id)))),
        ...results.filter((res) => ((res.id_identificacao_empresa !== Number(id) && res.utilizar_mesma_prova === 'N'))),
      ];

      const options = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < results.length; i++) {
        if ((!filtrar.includes(results[i].id))) {
          options.push({
            value: results[i].id,
            label: results[i].id_identificacao_empresa !== Number(id) ? `${results[i].descricao_disciplina}`
              : `${results[i].descricao_disciplina} - VINCULADO`,
          });
        }
      }

      setResult(options);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      toast.error(e.message);
    }
  };

  const handleChange = (value) => {
    if (value.length === 0) {
      setResult([]);
    } else {
      getDatas(value);
    }
  };

  const onChange = async (data) => {
    if (data.value) {
      setIdCadastrado(data.value);

      try {
        setIsLoading(true);
        const dados = await axios(`/disciplina/${data.value}`);

        const results = dados.data;

        setNivelCurso(results.curso_nivel);
        setDescricaoDisciplina(results.descricao_disciplina);
        setQuantidadeQuestoes(results.quantidade_questoes);
        setReutilizarProva(results.utilizar_mesma_prova);
        setTiposProva(results.tipos_de_prova);

        if (results.id_identificacao_empresa !== Number(id)) {
          setShow(true);
        }

        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
  };

  const handleClick = () => {
    setIdCadastrado('');
    setNivelCurso('');
    setDescricaoDisciplina('');
    setQuantidadeQuestoes('');
    setReutilizarProva('');
    setTiposProva('');
  };

  const handleDisciplina = async () => {
    try {
      const dados = await axios(`/disciplina/${idCadastrado}`);

      const results = dados.data;

      if (results.id_identificacao_empresa !== Number(id)) {
        const data = await axios.post('/disciplina/', {
          id_identificacao_empresa: id,
          curso_nivel: nivelCurso,
          descricao_disciplina: descricaoDisciplina,
          quantidade_questoes: quantidadeQuestoes,
          utilizar_mesma_prova: reutilizarProva,
          tipos_de_prova: tiposProva,
          id_disciplina_mesma_prova: results.id,
        });

        const questoes = await axios(`/questoes/${idCadastrado}`);

        setIdCadastrado(data.data.id);

        if (questoes.data.length > 0) {
          questoes.data.map((questao) => (
            axios.post('/questoes/', {
              descricao_questao: questao.descricao_questao,
              quantidade_de_alternativas: questao.quantidade_de_alternativas,
              peso: questao.peso,
              tipo_prova: questao.tipo_prova,
              numero_da_questao: questao.numero_da_questao,
              id_disciplina: data.data.id,
            }).then(async (res) => {
              const alternativa = await axios(`/alternativas/${questao.id}`);

              const altData = alternativa.data;

              axios.post(
                '/alternativas/',
                {
                  alternativa_1: altData.alternativas.alternativa_1,
                  alternativa_2: altData.alternativas.alternativa_2,
                  alternativa_3: altData.alternativas.alternativa_3,
                  alternativa_4: altData.alternativas.alternativa_4,
                  alternativa_5: altData.alternativas.alternativa_5,
                  resposta_correta: altData.resposta_correta,
                  id_questoes: res.data.id,
                },
              );
            }).catch((er) => {
              toast.error('Disciplina vinculada com sucesso!');
            })

          ));
        }
      } else {
        toast.error('Disciplina já vinculada');
      }

      setShow(false);
    } catch (err) {
      setShow(false);
      toast.error('Não foi possível vincular esta disciplina a este concurso.');
    }
  };

  const close = () => {
    setShow(false);
    setNivelCurso('');
    setDescricaoDisciplina('');
    setQuantidadeQuestoes('');
    setReutilizarProva('');
    setTiposProva('');
  };

  return (
    <Container>

      <Modal show={show} handleFunction={(handleDisciplina)} close={close}>
        Você tem certeza que você quer vincular este concurso a esta disciplina?
      </Modal>

      <Loading isLoading={isLoading} />

      <Select
        options={result}
        onInputChange={handleChange}
        onChange={onChange}
        placeholder="Pesquisar Disciplina..."
      />

      <Adicionar className="adicionar" onClick={handleClick}>
        <FaPlus size={16} />
        <p>Adicionar Disciplina</p>
      </Adicionar>

      <Form onSubmit={(e) => (handleSubmit(e))}>
        <label htmlFor="nivel-curso">
          Nível do curso
          <input
            id="nivel-curso"
            type="text"
            value={nivelCurso}
            onChange={(e) => setNivelCurso(e.target.value)}
            placeholder="Nível do curso"
          />
        </label>
        <label htmlFor="descricao-disciplina">
          Descrição da disciplina
          <input
            id="descricao-disciplina"
            type="text"
            value={descricaoDisciplina}
            onChange={(e) => setDescricaoDisciplina(e.target.value)}
            placeholder="Descrição da disciplina"
          />
        </label>
        <label htmlFor="quantidade-questoes">
          Quantidade de questões
          <input
            id="quantidade-questoes"
            type="number"
            max="20"
            min="5"
            value={quantidadeQuestoes}
            onChange={(e) => setQuantidadeQuestoes(e.target.value)}
            placeholder="Quantidade de questões"
          />
        </label>
        <label htmlFor="reutilizar-prova">
          Utilizar a prova para outros concursos
          <select value={reutilizarProva} id="reutilizar-prova" onChange={(e) => setReutilizarProva(e.target.value)}>
            <option value="" disabled>Selecione</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </label>
        <label htmlFor="quantidade-provas">
          Quantidade de provas
          <input
            id="quantidade-provas"
            type="number"
            max="3"
            min="1"
            value={tiposProva}
            onChange={(e) => setTiposProva(e.target.value)}
            placeholder="Quantidade de provas"
          />
        </label>

        <div id="submit-disciplina">
          <button type="submit">{!idCadastrado ? 'Cadastrar' : 'Editar'}</button>
          {idCadastrado && nivel !== '1' && (
            <Link to={`/questoes/${idCadastrado}/${quantidadeQuestoes}`}>
              Adicionar Questões
            </Link>
          )}
        </div>
      </Form>

    </Container>
  );
}

Disciplina.propTypes = {
  match: PropTypes.shape({}).isRequired,
};
